import fastdom from 'fastdom';
import { onArticleSearchResultsLoaded$, onloadingArticleSearchResults$ } from 'features/articleSearchResultsFacets';

// function to scroll to top of the page when a new results are fetching
const scrollToTopPage = function(){
    fastdom.mutate(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) })
}

// function to display the html response of articles
const renderArticleResults = function(htmlResponse) {
    const articlesContainer = document.querySelector('[data-component="blog-article-search-results"]');
    if(!articlesContainer) {return;}

    fastdom.mutate(() => {
        articlesContainer.innerHTML = htmlResponse;
        if(!htmlResponse){
            articlesContainer.setAttribute('hidden', '');
        }
    });
};

// Subscribe to the observables to trigger the scroll and render functions
onloadingArticleSearchResults$.subscribe(scrollToTopPage);
onArticleSearchResultsLoaded$.subscribe(renderArticleResults);